export default {
    name: 'rx-footer',
    props: {
    }
}